import React from 'react'
import FrequencyForm from './FrequencyForm'
import { Range } from '@medeo/components'

const HeartRateTarget = () => (
  <div>
    {' '}
    <Range
      min={0}
      max={250}
      step={1}
      color="#FF5D5D"
      label="pulsations (bpm)"
      items={[
        {
          low: 55,
          nameLow: 'bpm-verylow',
          high: 130,
          nameHigh: 'bpm-veryhigh',
          color: '#F19E40'
        },
        {
          low: 70,
          nameLow: 'bpm-low',
          high: 120,
          nameHigh: 'bpm-high',
          color: '#57DA92'
        }
      ]}
    />
    <FrequencyForm name="heartRate" />
  </div>
)

export default HeartRateTarget



// WEBPACK FOOTER //
// ./src/Goal/components/HeartRateTarget.js